import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles.css'

// Office.onReady wires the taskpane into Word. Outside of Word (regular
// browser preview) Office.js is still loaded but resolves as `host === null`,
// which we treat as "unsupported" — the panel renders the /review/file notice.
Office.onReady(() => {
  const root = document.getElementById('root')
  if (!root) throw new Error('Missing #root')
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
})
